export const shouldUseServiceWorker = (environment: { PROD: boolean } = import.meta.env) =>
  environment.PROD;

export const isAppServiceWorkerScript = (scriptUrl?: string, origin = window.location.origin) => {
  if (!scriptUrl) return false;
  try {
    const url = new URL(scriptUrl);
    return url.origin === origin && url.pathname === '/service-worker.js';
  } catch {
    return false;
  }
};

export const isAppServiceWorkerRegistration = (
  registration: ServiceWorkerRegistration,
  origin = window.location.origin,
) =>
  registration.scope === `${origin}/` &&
  [registration.active, registration.waiting, registration.installing].some(worker =>
    isAppServiceWorkerScript(worker?.scriptURL, origin),
  );

export const unregisterDevelopmentAppServiceWorkers = async (
  serviceWorkerContainer: Pick<ServiceWorkerContainer, 'getRegistrations'>,
  origin: string,
) => {
  const registrations = await serviceWorkerContainer.getRegistrations();
  return Promise.all(
    registrations
      .filter(registration => isAppServiceWorkerRegistration(registration, origin))
      .map(registration => registration.unregister()),
  );
};
